import React, { Component } from 'react';
import SubmitURL from './submitURL';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as submitURLActions from './submitURLActions';

class SubmitURLForm extends Component {

	handleSubmit(values) {
		const { submitURLActions, history } = this.props;
		const newWindow = window.open('https://timeoffledger.com/', '_blank');
		if (newWindow) {
			newWindow.focus();
		}

		submitURLActions.onSubmitBookmark({ url: values.url, storyTitle: values.storyTitle, description: values.description, categoryId: values.categoryId, navigation: history });

	}

	componentDidMount() {
		const { submitURLActions } = this.props;
		submitURLActions.onGetCategories();
	}

	render() {
		const { isLoading, categoryLists } = this.props;
		return (
			<div style={{ display: 'inline-flex', width: '100%' }}>
				<div style={{ paddingTop: '3%', width: '8%' }}>
				</div>
				<div style={{ width: '64%' }}>
					<SubmitURL
						onSubmit={this.onSubmit}
						isLoading={isLoading}
						categoryLists={categoryLists}
						handleSubmitBtn={values => this.handleSubmit(values)}
					/>
				</div>
				{/* <div style={{width: '26%', float: 'right'}}>
			<a href="https://www.oneplacetools.com/">
			<img
			  src="https://socialbookmarkeropenimages.s3.eu-west-2.amazonaws.com/advertiseBanner.gif"
			  style={{ paddingTop: "15%"}}
			/>
		  </a>
			</div> */}
			</div>
		);
	}
}


const mapStateToProps = ({ submitURL }) => {
	const { isLoading, categoryLists } = submitURL;
	return {
		isLoading,
		categoryLists,
	};
};



const mapDispatchToProps = (dispatch) => {
	return {
		submitURLActions: bindActionCreators(submitURLActions, dispatch),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SubmitURLForm));